import { controls } from "../../controls";

const rp965 = {
  label: "Government Security Investment Info",
  pageLabel: "Govt Security Investment Info",
  starting: true,
  url: "rp965",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [


    ...controls.displayText({tab: "filter",label: "Opening Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"opening_date",width:"col-sm-2"}),
    
//...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({tab: "filter",label: "From Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"from_date",width:"col-sm-2"}),
    
   // ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),
    
    ...controls.displayText({tab: "filter",label: "To Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"to_date",width:"col-sm-2"}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  form:[],

  history: {
    perPage: 10,
    reportHeader: "Government Security Investment Information",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
          {
            Header: "Sr. No.",
            accessor: "sr_no",
            width: 50,
            rwidth:"*"
          },

          {
            Header: "Name of security",
            width: 200,
            accessor: "name_of_security"
          },

          {
            Header: "Openig Balance",
            accessor: "opening_balance",
            type:"currency"           
          },      

          {
            Header: "Purchase",
            accessor: "purchase",
            type:"currency"               
          },

          {
            Header: "Sale",
            accessor: "sale",
            type:"currency"             
          },
          
          {
            Header: "Closing Balance",
            accessor: "closing_balance",
            type:"currency"                  
          },

          {
            Header: "Book Value",
            accessor: "book_value",
            type:"currency"               
          },
          {
            Header: "Market Rate",
            accessor: "market_rate",
            type:"currency"    
          },

          {
            Header: "Closing (as per Market Rate) in Rs.",
            accessor: "closing_as_per_market_rate_in_rs",
            type:"currency"              
          }
    ]
  }
};

export default rp965;